import Home from './Home'

export {
  Home
}


// WEBPACK FOOTER //
// ./src/screens/Home/index.js